import React from 'react';
import PromotionPrerequisiteAckModal from '../PromotionPrerequisiteAckModal';
import type { PromotionPrerequisiteIssue } from '../../../services/BaseBackendService';
import FundInvestmentInvestor from '../../../models/admin/FundInvestmentData';
import InvestorBulkPromoteModal from './InvestorBulkPromoteModal';
import InvestorInvestmentPromptModal from './InvestorInvestmentPromptModal';
import type { BulkPromoteInvestorItem } from './investorManagementTypes';

export interface InvestorManagementOverlaysProps {
  investmentPromptModalOpen: boolean;
  investmentPromptStage?: FundInvestmentInvestor['status'];
  investmentPromptInvestor?: FundInvestmentInvestor;
  investmentPromptAmount?: string;
  investmentPromptError?: string;
  bulkPromoteModalOpen: boolean;
  bulkPromoteStage?: FundInvestmentInvestor['status'];
  bulkPromoteInvestors?: BulkPromoteInvestorItem[];
  promotionPrerequisiteModalOpen?: boolean;
  promotionPrerequisiteIssues?: PromotionPrerequisiteIssue[];
  promotionPrerequisiteConfirmInProgress?: boolean;
  onCloseInvestmentPrompt: () => void;
  onInvestmentPromptAmountChange: (value: string) => void;
  onSubmitInvestmentPrompt: () => void;
  onCloseBulkPromote: () => void;
  onSubmitBulkPromotion: () => void;
  onUpdateBulkPromoteAmount: (
    id: string,
    field: 'preferredInvestment' | 'committedInvestment',
    value: string,
  ) => void;
  onRemoveBulkPromoteInvestor: (id: string) => void;
  onClosePromotionPrerequisite: () => void;
  onConfirmPromotionPrerequisite: () => void;
}

export default function InvestorManagementOverlays({
  investmentPromptModalOpen,
  investmentPromptStage,
  investmentPromptInvestor,
  investmentPromptAmount,
  investmentPromptError,
  bulkPromoteModalOpen,
  bulkPromoteStage,
  bulkPromoteInvestors,
  promotionPrerequisiteModalOpen,
  promotionPrerequisiteIssues,
  promotionPrerequisiteConfirmInProgress,
  onCloseInvestmentPrompt,
  onInvestmentPromptAmountChange,
  onSubmitInvestmentPrompt,
  onCloseBulkPromote,
  onSubmitBulkPromotion,
  onUpdateBulkPromoteAmount,
  onRemoveBulkPromoteInvestor,
  onClosePromotionPrerequisite,
  onConfirmPromotionPrerequisite,
}: InvestorManagementOverlaysProps) {
  return (
    <>
      <InvestorInvestmentPromptModal
        open={investmentPromptModalOpen}
        stage={investmentPromptStage}
        investor={investmentPromptInvestor}
        amount={investmentPromptAmount}
        error={investmentPromptError}
        onClose={onCloseInvestmentPrompt}
        onAmountChange={onInvestmentPromptAmountChange}
        onSubmit={onSubmitInvestmentPrompt}
      />
      {bulkPromoteStage ? (
        <InvestorBulkPromoteModal
          open={bulkPromoteModalOpen}
          stage={bulkPromoteStage}
          investors={bulkPromoteInvestors}
          onClose={onCloseBulkPromote}
          onSubmit={onSubmitBulkPromotion}
          onUpdateAmount={onUpdateBulkPromoteAmount}
          onRemoveInvestor={onRemoveBulkPromoteInvestor}
        />
      ) : null}
      <PromotionPrerequisiteAckModal
        open={!!promotionPrerequisiteModalOpen}
        issues={promotionPrerequisiteIssues ?? []}
        inProgress={promotionPrerequisiteConfirmInProgress}
        onCancel={onClosePromotionPrerequisite}
        onConfirm={onConfirmPromotionPrerequisite}
      />
    </>
  );
}
